<template>
  <div class="main-wrapper">
    <Loader :isVisible="isLoading" />
    <EventForm
      :handleFormChange="handleFormChange"
      :formPrefix="'eventGroup'"
      :isGroup="true"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SET_EDIT_FORM } from '../../store/actions/common';
import EventForm from '../../components/forms/EventForm.vue';
import Loader from '../../components/common/Loader.vue';
import CONFIG from '../../constants/config';

export default {
  name: 'EditEventGroup',
  components: {
    Loader,
    EventForm,
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.eventGroups.isLoading,
      isEditedForm: (state) => state.common.isEditedForm,
    }),
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventNav);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEditedForm) {
      // eslint-disable-next-line no-alert
      if (!window.confirm(CONFIG.confirmationLeaveMessage)) {
        this.$router.push(this.$route.path);
        return;
      }
      this.$store.dispatch(SET_EDIT_FORM, false);
    }
    next();
  },
  created() {
    const s = this.$route.name;
    document.title = s[0].toUpperCase() + s.slice(1);
  },
  methods: {
    preventNav(event) {
      if (this.isEditedForm) {
        event.returnValue = CONFIG.confirmationLeaveMessage;
      }
    },
    handleFormChange(value) {
      this.$store.dispatch(SET_EDIT_FORM, value);
    },
  },
};
</script>

<style scoped>
  .main-wrapper {
    padding: 33px 29px;
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 25px 25px 25px 30px;
    width: 100%;
    margin-right: 5px;
    overflow-y: auto;
    flex: 1;
    height: 90vh;
  }
</style>
